window._pa = window._pa || {};
window._pa.$ = ((/** @type {PAjQueryHelpers} */ _$, $) => {
  if (!$) {
    console.error('[jquery_helper] jQuery 라이브러리가 로드되지 않았습니다.');
    return _$;
  }

  _$.submit = (selector) => {
    $(selector).submit();
  };

  return _$;
})(window._pa.$ || {}, window.jQuery);

/**
 * @callback submit
 * @param {string} selector 폼 요소를 가리키는 셀렉터
 * @returns {void}
 */

/**
 * @typedef {object} PAjQueryHelpers
 * @property {PAjQueryHelpers} submit 셀렉터로 매칭된 폼에 대해 jQuery .submit()을 호출하는 유틸리티
 */
